module.exports = __webpack_public_path__ + "img/shouye.5ed9e978.svg";